<template>
  <div v-rect-loading="loading" class="email-container">
    <div class="email-editor-header">
      <div class="email-editor-title">{{ $t(`${i18nPrefix}.title.${emailInfo.currentEmailAddress ? 'changeEmailRequest' : 'bindEmailRequest'}`) }}</div>
    </div>
    <div class="email-info-container">
      <WrappedFrom
        hideRequiredAsterisk
        ref="form"
        class="email-info"
        :model="emailInfo"
        :formLines="formLines"
      >
      </WrappedFrom>
      <div class="bottom-btn-group">
        <el-button class="save-btn" type="primary" @click="handleSave">{{ $t('common.btn.submit') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import WrappedFrom from '@/components/formEditor/wrappedForm.vue'
import { validateEmail } from '@/utils/validator'
import { passwordEncrypt } from '@/utils/rsa'

export default {
  components: {
    WrappedFrom
  },
  props: {
  },
  data () {
    return {
      i18nPrefix: 'personal.functions.changeEmail',
      loading: false,
      personalInfo: null,
      emailInfo: {
        currentEmailAddress: null,
        newEmailAddress: null,
        password: null
      }
    }
  },
  computed: {
    formLines () {
      const lines = {
        currentEmailAddress: {
          label: this.$t(`${this.i18nPrefix}.label.currentEmail`),
          disabled: true,
          hidden: !this.emailInfo.currentEmailAddress
        },
        newEmailAddress: {
          label: this.$t(`${this.i18nPrefix}.label.newEmail`),
          rules: [
            {
              required: true,
              trigger: 'blur',
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error(this.$t('common.message.requiredFormField')))
                } else if (value === this.emailInfo.currentEmailAddress) {
                  callback(new Error(this.$t(`${this.i18nPrefix}.message.youAreUsingTheEmail`)))
                } else {
                  callback()
                }
              }
            },
            { validator: validateEmail, trigger: 'blur' }
          ]
        },
        password: {
          label: this.$t(`${this.i18nPrefix}.label.password`),
          rules: [
            { required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }
          ],
          props: { type: 'password' },
          hidden: !this.personalInfo?.exist_password
        }
      }

      return lines
    },
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    this.loadPersonalInfo()
  },
  methods: {
    ...mapActions('account', ['inviteConfirmChangeEmail']),
    ...mapActions('personal', ['getPersonalInfo']),
    async loadPersonalInfo () {
      this.loading = true
      try {
        const resp = await this.getPersonalInfo({ company_id: this.companyId })
        if (resp) {
          this.personalInfo = resp
          this.emailInfo.currentEmailAddress = this.personalInfo.email_address
        }
      } finally {
        this.loading = false
      }
    },
    async handleSave () {
      const result = await this.$refs.form.submit()
      if (!result) {
        return
      }

      this.loading = true
      try {
        const params = {
          new_email_address: this.emailInfo.newEmailAddress,
          password: passwordEncrypt(this.emailInfo.password)
        }
        await this.inviteConfirmChangeEmail(params)
        this.$message.success(this.$t(`${this.i18nPrefix}.message.requestSuccess`))

        this.emailInfo.newEmailAddress = null
        this.emailInfo.password = null
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.email-container {
  min-height: calc(100vh - var(--header-height, 124px) - 28px);
  min-height: calc(100dvh - var(--header-height, 124px) - 28px);
  background-color: #fff;

  .email-editor-header {
    display: flex;
    position: sticky;
    top: -14px;
    height: 52px;
    padding: 16px 0 16px 40px;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .email-editor-title {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }
  }

  .email-info-container {
    width: 500px;
    margin: 80px auto 0;
  }

  .bottom-btn-group {
    display: flex;
    justify-content: flex-end;
    margin: 30px auto 0;

    .el-button {
      padding: 8px 28px;
      border-radius: 2px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #0096cc;

      &:last-child {
        margin-left: 24px;
        margin-right: 0;
        background: #0096cc;
        border-color: #0096cc;
        color: #ffffff;
      }
    }
  }
}
</style>
